import type { Capability } from 'owa-capabilities';
import { isCapabilityEnabled } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isConsumer } from 'owa-session-store';
import { headerAppLauncherCapability } from './headerAppLauncherCapability';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability gates the new service-driven, enterprise App Launcher
 * experience: pinned apps loaded from WebShell, search across the M365 app
 * catalog, and right-click context menu (Open in new tab / Pin / Unpin).
 *
 * `isSupported` covers the structural prerequisites: enterprise account and
 * the underlying header App Launcher capability is supported on this host.
 *
 * `isEnabled` covers the runtime/ramp gate: the `fwk-applauncher-pinned-apps`
 * flight.
 */
export const enterpriseAppLauncherCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled('fwk-applauncher-pinned-apps');
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (
            !isConsumer(undefined, mailboxInfo) &&
            isCapabilityEnabled(headerAppLauncherCapability, mailboxInfo)
        );
    },
};
